import { z } from 'zod'

export const actionFormSchema = z.object({
  type: z.string(),
  name: z.string(),
  title: z.string(),
  source: z.string().optional(),
  default: z.string().or(z.number()).optional(),
})

export const actionRequestSchema = z.object({
  mapping: z.array(z.object({ type: z.string(), name: z.string(), title: z.string() })),
})

export const actionItemSchema = z.object({
  title: z.string(),
  name: z.string(),
  description: z.string(),
  guidance: z.string().optional(),
  forms: z.array(actionFormSchema),
  requests: z.array(actionRequestSchema),
  innerFields: z.array(z.string().or(z.void())),
})

export type ActionItem = z.infer<typeof actionItemSchema>
export type ActionRequest = z.infer<typeof actionRequestSchema>
export type ActionForm = z.infer<typeof actionFormSchema>
